import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { AdvancedShiftPage } from '@/features/shifts/pages/advanced-shift-page'

export const Route = createFileRoute('/_authenticated/_organization/shifts/$shiftId/edit')({
  beforeLoad: async () =>
    requireRoles([
      'owner',
      'admin',
      'team_leader',
      'support_coordinator',
    ]),
  component: AdvancedShiftPage,
})
